import React from 'react';
export function Hero() {
  const scrollToPricing = () => {
    const el = document.getElementById('pricing');
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <div className="pt-16 pb-12 px-4 max-w-4xl mx-auto text-center" data-id="element-150">
      <div className="inline-block bg-brand-card border border-brand-borderGlow/30 rounded-full px-4 py-1.5 font-heading font-semibold text-brand-subtitle mb-6 text-[12px] tracking-[0.15em] uppercase shadow-violet-glow" data-id="element-151">
        💃 ATENCIÓN: INSTRUCTORES DE BACHATA
      </div>

      <h1 className="font-display text-brand-title md:text-6xl font-bold tracking-tight mb-8 text-[40px] leading-tight" data-id="element-152">
        ¿Te quita tiempo planificar tus clases? Resuélvelo hoy.
      </h1>

      <div className="my-10 md:my-12 flex justify-center" data-id="element-153">
        <img src="https://cdn.magicpatterns.com/uploads/cJGzsbT4NRJ27eXKnkWyh3/mockup_sin_fondo_webp.png" alt="El Manual del Instructor de Bachata — 6 Tomos + 3 Bonos" width={800} height={800} fetchPriority="high" loading="eager" decoding="async" className="w-full max-w-2xl drop-shadow-[0_20px_50px_rgba(226,149,168,0.3)]" data-id="element-154" />
      </div>

      <p className="font-heading text-xl md:text-2xl text-brand-subtitle font-semibold mb-8 tracking-wide" data-id="element-155">
        Deja de improvisar. Empieza a enseñar con estructura, seguridad y
        resultados.
      </p>

      <div className="flex items-center justify-center gap-2 mb-8 text-sm" data-id="element-156">
        <div className="flex text-brand-gold" data-id="element-157">⭐⭐⭐⭐⭐</div>
        <span className="font-body text-brand-text font-medium" data-id="element-158">4.9/5</span>
        <span className="text-brand-textMuted" data-id="element-159">·</span>
        <span className="font-body text-brand-text font-medium" data-id="element-160">
          🔥 24 instructores lo compraron hoy
        </span>
      </div>

      <button onClick={scrollToPricing} className="font-heading bg-gradient-gold hover:opacity-90 text-brand-bg font-bold text-xl md:text-2xl py-5 px-10 rounded-2xl transition-all hover:scale-105 active:scale-95 shadow-gold-glow-lg w-full md:w-auto mb-6 tracking-wide" data-id="element-161">
        🚀 ¡QUIERO MI MANUAL AHORA!
      </button>

      <div className="text-brand-textMuted font-medium text-sm tracking-wide" data-id="element-162">
        🇪🇸 +300 instructores ya enseñan mejor en España
      </div>
    </div>;
}